import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Row, Column, Container, FlexColumn, FlexRow, ServicingSection } from 'web-ui-components/lib/global/layout';
import { cx } from 'react-emotion';
import moment from 'moment';
import { Label } from 'web-ui-components/lib/atoms/forms';
import styles from '../../../bacs/components/BacsPaymentsPage/BacsPaymentStyles';
import FromAccount, { DestinationAccount } from '../../../sharedComponents/FromAccount/FromAccount';
import { updateValidation, hideErrorMsg } from '../../../states/validation/actions';
import SubmissionDate from '../../../bacs/components/BacsPaymentsPage/Form/SubmissionDate';
import PaymentName from '../../../bacs/components/BacsPaymentsPage/Form/PaymentName';
import BacsId from '../../../bacs/components/BacsPaymentsPage/Form/BacsId';
import { fromAccountPropType } from '../../../states/accounts/propTypes';
import { bacsNameMaxLength, dateFormat } from '../../../config';
import pageContent, { contentPropTypes } from '../bacs/importedPayments.content';
import { RenderPopper } from '../../../sharedComponents/RenderPopper/RenderPopper';
import withContent from '../../../containers/withContent';

const mapDispatch = (dispatch) => ({
	updateValidation: (key, isValid) =>
		dispatch(
			updateValidation({
				id: 'from',
				key,
				isValid,
			})
		),
	hideErrorMsg: (key) =>
		dispatch(
			hideErrorMsg({
				id: 'from',
				key,
			})
		),
});

class BacsUploadBody extends Component {
	constructor(props) {
		super(props);
		this.state = {
			popovers: {},
			showValidation: true,
		};
		this.togglePopover = this.togglePopover.bind(this);
	}

	togglePopover(key) {
		this.setState((state) => ({
			popovers: {
				[key]: !state.popovers[key],
			},
		}));
	}
	render() {
		const {
			bacsId,
			bacsIds,
			bacsLimit,
			destinationAccount,
			destinationAccounts,
			fromAccount,
			fromAccounts,
			showFromAccountSelector,
			showDestinationAccountSelector,
			validations,
			updateValidation,
			hideErrorMsg,
			submissionDate,
			settlementDate,
			handleBacsIdChange,
			handleDateChange,
			handlePaymentNameChange,
			handleSelectDestinationAccount,
			handleSelectFromAccount,
			handleDestinationCardClick,
			handleFromCardClick,
			isCredit,
			content,
			paymentName,
		} = this.props;
		const { showValidation, popovers } = this.state;
		const {
			toLabel,
			fromLabel,
			bacsIdLabel,
			bacsIdInvalid,
			bacsIdPopperBody,
			bacsIdDescription,
			paymentNameLabel,
			paymentNamePopperBody,
			paymentNameDescription,
			paymentNameRequirements,
			settlementDateLabel,
			settlementDatePopperBody,
			settlementDateDescription,
			collectionDateLabel,
			collectionDatePopperBody,
			collectionDateDescription,
			submissionDateLabel,
			submissionDatePopperBody,
			submissionDateDescription,
		} = content;
		return (
			<ServicingSection padded={false}>
				<Container className={cx(styles.container, styles.main__container)}>
					<Row>
						<Column xs={24}>
							<FlexRow>
								<FlexColumn key="fromAccount" proportion={1}>
									<div className={styles.field__label}>
										<Label className="u-type-size-uist" htmlFor="fromAccount">
											{isCredit ? fromLabel : toLabel}
										</Label>
									</div>
									{isCredit ? (
										<FromAccount
											id="fromAccount"
											fromAccount={fromAccount}
											showAccountSelector={showFromAccountSelector}
											fromAccounts={fromAccounts}
											handleSelectFromAccount={handleSelectFromAccount}
											handleCardClick={handleFromCardClick}
											showValidation={showValidation}
											validations={validations}
											updateValidation={updateValidation}
											hideErrorMsg={hideErrorMsg}
										/>
									) : (
										<DestinationAccount
											id="toAccount"
											fromAccount={destinationAccount}
											showAccountSelector={showDestinationAccountSelector}
											fromAccounts={destinationAccounts}
											handleSelectFromAccount={handleSelectDestinationAccount}
											handleCardClick={handleDestinationCardClick}
											showValidation={showValidation}
											validations={validations}
											updateValidation={updateValidation}
											hideErrorMsg={hideErrorMsg}
											title={toLabel}
										/>
									)}
								</FlexColumn>
								<FlexColumn key="submissionDate" proportion={1}>
									<div className={styles.field__label}>
										<Label className="u-type-size-uist" htmlFor="submissionDate">
											{submissionDateLabel}
										</Label>
										<RenderPopper
											id="submissionDate"
											content={submissionDatePopperBody}
											isOpen={popovers.submissionDate}
											togglePopover={this.togglePopover}
										/>
									</div>
									<SubmissionDate date={submissionDate} handleDateChange={handleDateChange} />
									<span className={styles.main__description}>{submissionDateDescription}</span>
								</FlexColumn>
								<FlexColumn key="settlementDate">
									<div className={styles.field__label}>
										<Label className="u-type-size-uist" htmlFor="settlementDate">
											{isCredit ? settlementDateLabel : collectionDateLabel}
										</Label>
										<RenderPopper
											id="settlementDate"
											content={isCredit ? settlementDatePopperBody : collectionDatePopperBody}
											isOpen={popovers.settlementDate}
											togglePopover={this.togglePopover}
										/>
									</div>
									<div className={styles.static__field}>{settlementDate ? settlementDate.format(dateFormat) : ''}</div>
									<span className={styles.main__description}>
										{isCredit ? settlementDateDescription : collectionDateDescription}
									</span>
								</FlexColumn>
							</FlexRow>
							<FlexRow>
								<FlexColumn key="paymentName" proportion={1}>
									<div className={styles.field__label}>
										<Label className="u-type-size-uist" htmlFor="paymentName">
											{paymentNameLabel}
										</Label>
										<RenderPopper
											id="paymentName"
											content={paymentNamePopperBody}
											isOpen={popovers.paymentName}
											togglePopover={this.togglePopover}
										/>
									</div>
									<PaymentName
										id="paymentName"
										paymentName={paymentName}
										maxLength={bacsNameMaxLength}
										onBlur={handlePaymentNameChange}
										description={paymentNameRequirements}
									/>
									<span className={styles.main__description}>{paymentNameDescription}</span>
								</FlexColumn>
								<FlexColumn key="bacsId">
									<div className={styles.field__label}>
										<Label className="u-type-size-uist" htmlFor="bacsId">
											{bacsIdLabel}
										</Label>
										<RenderPopper
											id="bacsId"
											content={bacsIdPopperBody}
											isOpen={popovers.bacsId}
											togglePopover={this.togglePopover}
										/>
									</div>
									<BacsId
										bacsIdOptions={bacsIds}
										bacsId={bacsId}
										onChange={handleBacsIdChange}
										showValidation={showValidation}
										invalidMessage={bacsIdInvalid}
										validations={validations}
										updateValidation={updateValidation}
										hideErrorMsg={hideErrorMsg}
									/>
									{bacsLimit && (
										<span id="bacsIdLimit" className={styles.main__description}>
											{bacsLimit}
										</span>
									)}
									<span className={styles.main__description}>{bacsIdDescription}</span>
								</FlexColumn>
							</FlexRow>
						</Column>
					</Row>
				</Container>
			</ServicingSection>
		);
	}
}
BacsUploadBody.default = {
	isCredit: false,
};

BacsUploadBody.propTypes = {
	bacsId: PropTypes.string,
	bacsIds: PropTypes.arrayOf(PropTypes.string),
	bacsLimit: PropTypes.string,
	destinationAccount: PropTypes.string,
	destinationAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)),
	fromAccount: PropTypes.string,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape(fromAccountPropType)),
	showFromAccountSelector: PropTypes.boolean,
	showDestinationAccountSelector: PropTypes.boolean,
	validations: PropTypes.shape({}),
	updateValidation: PropTypes.func,
	hideErrorMsg: PropTypes.string,
	paymentName: PropTypes.string,
	submissionDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]),
	settlementDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]),
	popovers: PropTypes.shape({}),
	handleBacsIdChange: PropTypes.func,
	handleDateChange: PropTypes.func,
	handlePaymentNameChange: PropTypes.func,
	handleSelectDestinationAccount: PropTypes.func,
	handleDestinationCardClick: PropTypes.func,
	handleSelectFromAccount: PropTypes.func,
	handleFromCardClick: PropTypes.func,
	isCredit: PropTypes.boolean,
	content: PropTypes.shape(contentPropTypes).isRequired,
};

const contentWrapper = withContent({ content: pageContent })(BacsUploadBody);
export const connectWrapper = compose(connect(null, mapDispatch))(contentWrapper);
